// Individual tour steps
var tourSteps = [
    {
        element: "#tourStep1",
        title: "Date of referral",
        content: "Defaults to today’s date. You can backdate it but you cannot post-date it",
        template:   "<div class='popover tour __referral'>" +
                    "<div class='arrow'></div>" +
                    "<button class='btn __close' data-role='end'><span class='sronly'>End tour</span></button>" +
                    "<div class='popover-image-wrap'>" +
                    "<img class='popover-image' src='https://placehold.co/280x124' alt='image example'/>" +
                    "</div>" +
                    "<div class='popover-content-wrap'>" +
                    "<h3 class='popover-title'></h3>" +
                    "<div class='popover-content'></div>" +
                    "<div class='popover-navigation'>" +
                    "<button class='btn __lightpurpletext ' data-role='prev'>Prev</button>" +
                    "<button class='btn __lightpurple' data-role='next'>Next</button>" +
                    "</div>" +
                    "</div>" +
                    "</div>"
    },
    {
        element: "#tourStep2",
        title: "Resident/non resident",
        content: "Defaults to resident but non-resident can be selected",
        placement: "left",
    },
    {
        element: "#tourStep3",
        title: "Currency",
        content: "This Defaults to local currency per bank but you can choose another currency if you require another currency",
        placement: "top",
    },
    {
        element: "#tourStep4",
        title: "Account holding bank",
        content: "select bank that you wish to open an account with",
        placement: "bottom",
    },
    {
        element: "#tourStep5",
        title: "Business activity",
        content: "a brief description of the type of business performed by the account holder/customer. E.g. Logistics, Manufacturer, Financial Services, Software Developer, Electronics etc",
        template:   "<div class='popover tour __referral'>" +
                    "<div class='arrow'></div>" +
                    "<button class='btn __close' data-role='end'><span class='sronly'>End tour</span></button>" +
                    "<div class='popover-image-wrap'>" +
                    "<img class='popover-image' src='https://placehold.co/580x150' alt='image example'/>" +
                    "</div>" +
                    "<div class='popover-content-wrap'>" +
                    "<h3 class='popover-title'></h3>" +
                    "<div class='popover-content'></div>" +
                    "<div class='popover-navigation'>" +
                    "<button class='btn __lightpurpletext ' data-role='prev'>Prev</button>" +
                    "<button class='btn __lightpurple' data-role='next'>Next</button>" +
                    "</div>" +
                    "</div>" +
                    "</div>"
    },
    {
        element: "#tourStep6",
        title: "Additional services",
        content: "Any additional banking services required?"
    },
    {
        element: "#tourStep7",
        title: "Cash flow",
        content: "Please note that some account holding banks have a minimum cash flow requirement . Please refer to account holding banks profile with regards to cash flow requirements"
    },
    {
        element: "#tourStep8",
        title: "Ownership structure ",
        content: "this information will be used to determine the ultimate beneficiary  ownership. Please refer to the IBOS guide"
    },
    {
        element: "#tourStep9",
        title: "Notes",
        content: "this will be recorded in the audit trail for reference purposes"
    },
    {
        element: "#tourStep10",
        title: "Preview email",
        content: "this does not send an email, this provides an example so you can use this to identify missing information"
    },
    {
        element: "#tourStep11",
        title: "Save as draft",
        content: "This will be stored in the same place as a new referral, but it will not be sent. You can add further information at a later stage"
    },
    {
        element: "#tourStep12",
        title: "Submit",
        content: "this will result in an email being sent to the account holding bank. As it is not stored in the portal, you will get a copy of the email as a reference"
    }
]

// Counter for tour steps
$.each(tourSteps, function(i, step){
    step['title'] += '<div class="popover-count">'+(i+1)+' / '+tourSteps.length+'</div>';
});

// Tour settings
var tour = new Tour({
    container: "body",
    steps: tourSteps,
    backdrop: true,
    debug: true,
    delay: 1,
    template:   "<div class='popover tour __referral'>" +
                "<div class='arrow'></div>" +
                "<button class='btn __close' data-role='end'><span class='sronly'>End tour</span></button>" +
                "<div class='popover-image-wrap'></div>" +
                "<div class='popover-content-wrap'>" +
                "<h3 class='popover-title'></h3>" +
                "<div class='popover-content'></div>" +
                "<div class='popover-navigation'>" +
                "<button class='btn __lightpurpletext ' data-role='prev'>Prev</button>" +
                "<button class='btn __lightpurple' data-role='next'>Next</button>" +
                "</div>" +
                "</div>" +
                "</div>"
});

// Initialize the tour
// tour.init();
// tour.restart();

// Start the tour with a button click
// $("#my-element").click(function() {
//   tour.restart();
//   $(".popover tour").addClass('show');
// });
